export default __webpack_public_path__ + "static/group-insights-dark-mode-105af4f67248521d53a1e8bcd296db8c.png";